import { render, staticRenderFns } from "./DeleteGroupClassConfirmationDialog.vue?vue&type=template&id=2bd1a65c"
import script from "./DeleteGroupClassConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupClassConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports